import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.5.248H7.228a6.977 6.977 0 1 0 0 13.954h2.318a.25.25 0 0 1 .25.25V22.5a1.25 1.25 0 0 0 2.5 0V3a.25.25 0 0 1 .25-.25h3.682a.25.25 0 0 1 .25.25v19.5a1.25 1.25 0 0 0 2.5 0V3a.25.25 0 0 1 .25-.25H22.5a1.25 1.25 0 0 0 0-2.5ZM9.8 11.452a.25.25 0 0 1-.25.25H7.228a4.477 4.477 0 1 1 0-8.954h2.318A.25.25 0 0 1 9.8 3Z" }, null, -1)
  ]))]))
}
export default { render: render }